import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

/**
 * [HOTFIX] React 18 + React-Beautiful-DnD (RBD) Conflict
 * RBD tries to remove its <style> tags from <head> during unmount/re-render,
 * but sometimes React 18 has already detached them or moved them, 
 * causing a fatal "NotFoundError: child not found in parent" crash.
 * 
 * This targeted interceptor only blocks removeChild if:
 * 1. The child is NOT actually in the parent it's being removed from.
 * This targeted interceptor only blocks removeChild if:
 * 1. The child is NOT actually in the parent it's being removed from.
 * 2. The child is a <style> tag related to RBD (to avoid breaking Emotion/MUI v5).
 */
const originalRemoveChild = Node.prototype.removeChild;
Node.prototype.removeChild = function (child) {
  if (child.parentNode !== this) {
    if (console && (child.tagName === 'STYLE' || child.hasAttribute?.('data-rfd-always') || child.hasAttribute?.('data-rfd-dynamic'))) {
      // Silently prevent the crash for RBD style tags
      return child; 
    }
    // For other nodes, still check to avoid the fatal throw but keep the warning for debugging
    if (console) {
      console.warn("[RBD_FIX] Prevented fatal crash: child not in parent.", child);
    }
    return child; 
  }
  return originalRemoveChild.apply(this, arguments);
};

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
